import { type FormationExpressStore } from "services/formationExpress/formationExpressStore";
import { IssueKey, type IssuesStore } from "services/issues/issuesStore";
import { QuestionsStore } from "services/questions/questionsStore";
import { ISSUE_FIELD_TO_QUESTION, InitQuestions } from "./initConstants";

export class InitQuestionStore extends QuestionsStore<InitQuestions> {
  protected _issueKey = IssueKey.Init;
  protected _issueFieldsToQuestions = ISSUE_FIELD_TO_QUESTION;

  constructor(
    private readonly _formationExpressStore: FormationExpressStore,
    protected readonly _issuesStore: IssuesStore,
  ) {
    super(InitQuestions, _issuesStore);
  }

  protected _getRelevantQuestion(): InitQuestions | undefined {
    return this.firstQuestion;
  }

  protected _shouldSkipQuestion(question: InitQuestions): boolean {
    switch (question) {
      case InitQuestions.SameDayRegistration:
        return !this._formationExpressStore.needToShow;
    }

    return super._shouldSkipQuestion(question);
  }
}
